import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { AddonIcon } from '@app/components/AddonIcon';

import { GetCurrentAddOnsPayload } from '@mfe/shared/schema-types';

import OrderDetailsSection from '../OrderDetailsSection';

import styles from './styles.module.scss';

export const OptionalServices = ({ carryOverAddons }: { carryOverAddons: GetCurrentAddOnsPayload[] }) => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview',
  });

  return (
    <OrderDetailsSection id="optional-services" title={t('details.optionalServices.title')}>
      <div className={styles.spacer}>
        <Txt variant="bodySmallRegular">{t('details.optionalServices.description')}</Txt>
        <div className={styles.spacer}>
          {carryOverAddons.map(({ name, kind }) => (
            <div className={styles.product} key={name}>
              <AddonIcon kind={kind} className={styles.icon} />
              <Txt color="subtle" variant="heading5">
                {name}
              </Txt>
            </div>
          ))}
        </div>
      </div>
    </OrderDetailsSection>
  );
};
